import React from "react";
import {
    Box,
    Container,
    Typography,
    Grid,
    Card,
    Button,
    useTheme,
} from "@mui/material";
import BusinessIcon from "@mui/icons-material/Business";
import CodeIcon from "@mui/icons-material/Code";
import SupportIcon from "@mui/icons-material/Support";
import PageTransition from "./PageTransition";

const OverView = () => {
    const theme = useTheme();

    return (
        <Box sx={{ backgroundColor: "#e6f2ff", py: 6 }}>
            <PageTransition>
                <Container >
                    <Typography
                        variant="h4"
                        align="center"
                        gutterBottom
                        sx={{ fontWeight: "bold", color: theme.palette.secondary.main, mb: 5 }}
                    >
                        Our Expertise
                    </Typography>
                    <Typography
                        variant="h6"
                        align="center"
                        paragraph
                        sx={{ fontSize: "1.1rem", mb: 5 }}
                    >
                        We specialize in cutting-edge software development, providing
                        custom solutions tailored to your business needs.
                    </Typography>
                    <Grid container spacing={4} justifyContent="center">
                        {/* Service 1: Software Development */}
                        <Grid item xs={12} md={4}>
                            <Card
                                sx={{
                                    textAlign: "center",
                                    p: 3,
                                    transition: "all 0.3s ease",
                                    "&:hover": {
                                        boxShadow: "0 12px 20px rgba(0,0,0,0.1)",
                                        transform: "translateY(-10px)",
                                    },
                                }}
                            >
                                <CodeIcon sx={{ fontSize: 50, color: "#2196F3", mb: 3 }} />
                                <Typography variant="h6" fontWeight="bold" gutterBottom>
                                    Software Development
                                </Typography>
                                <Typography variant="body1" sx={{ mb: 3 }}>
                                    Our team builds high-performance, scalable, and secure software
                                    solutions tailored to meet your unique business needs.
                                </Typography>

                            </Card>
                        </Grid>

                        {/* Service 2: Business Solutions */}
                        <Grid item xs={12} md={4}>
                            <Card
                                sx={{
                                    textAlign: "center",
                                    p: 3,
                                    transition: "all 0.3s ease",
                                    "&:hover": {
                                        boxShadow: "0 12px 20px rgba(0,0,0,0.1)",
                                        transform: "translateY(-10px)",
                                    },
                                }}
                            >
                                <BusinessIcon sx={{ fontSize: 50, color: "#4CAF50", mb: 3 }} />
                                <Typography variant="h6" fontWeight="bold" gutterBottom>
                                    Business Solutions
                                </Typography>
                                <Typography variant="body1" sx={{ mb: 3 }}>
                                    We offer customized business solutions to improve efficiency,
                                    increase profitability, and enhance your customer experience.
                                </Typography>

                            </Card>
                        </Grid>

                        {/* Service 3: Support & Maintenance */}
                        <Grid item xs={12} md={4}>
                            <Card
                                sx={{
                                    textAlign: "center",
                                    p: 3,
                                    transition: "all 0.3s ease",
                                    "&:hover": {
                                        boxShadow: "0 12px 20px rgba(0,0,0,0.1)",
                                        transform: "translateY(-10px)",
                                    },
                                }}
                            >
                                <SupportIcon sx={{ fontSize: 50, color: "#FF9800", mb: 3 }} />
                                <Typography variant="h6" fontWeight="bold" gutterBottom>
                                    Support & Maintenance
                                </Typography>
                                <Typography variant="body1" sx={{ mb: 3 }}>
                                    Our team provides ongoing support and maintenance to ensure
                                    your systems remain up and running smoothly.
                                </Typography>

                            </Card>
                        </Grid>
                    </Grid>
                </Container>
            </PageTransition>
        </Box>
    );
};

export default OverView;
